import React from 'react';
import {DotsVerticalIcon} from "@heroicons/react/solid";
import {Menu} from "@headlessui/react";

// Component ----

function DropdownButton() {

  const classes = "rounded-full flex items-center text-gray-500 hover:text-gray-700 focus:outline-none " +
    "focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-100 focus-visible:ring-brand"

  return (
    <Menu.Button className={classes}>
      <span className="sr-only">Open options</span>
      <DotsVerticalIcon className="h-5 w-5" aria-hidden="true"/>
    </Menu.Button>
  );
}

export default DropdownButton;